<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 21.5C6.75283 21.5 2.5 17.2472 2.5 12C2.5 6.75283 6.75283 2.5 12 2.5C17.2472 2.5 21.5 6.75283 21.5 12C21.5 17.2472 17.2472 21.5 12 21.5Z"
      fill="currentColor"
    />
    <path
      d="M14.9872 9.01279L9.01277 14.9872"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.9872 14.9872L9.01277 9.01279"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
